import _ from "lodash";
import React, { useState, useMemo } from "react";
import { Button, Modal, TextInput } from "@toddle-edu/ds-web";
import classes from "./DialogActionModal.scss";
import TruncatedTextWithTooltip from "UIComponents/TruncatedTextWithTooltip/TruncatedTextWithTooltip";

const getModalBody = ({
  label,
  placeholder,
  inputValue,
  setInputValue,
  message,
  isPromptBox,
  dsVersion,
  testId,
}) => {
  if (isPromptBox) {
    return (
      <div className={classes.propmptBox}>
        <TextInput
          label={
            <div
              className={dsVersion == "2.0" ? "text-label-3" : "text-label-2"}
            >
              {label}
            </div>
          }
          placeholder={placeholder}
          value={inputValue}
          onChange={e => setInputValue(e.target.value)}
          size={dsVersion == "2.0" ? "medium" : "large"}
          dsVersion={dsVersion}
          autoFocus={true}
          testId={testId}
        />
      </div>
    );
  } else {
    return <div>{message}</div>;
  }
};

const DialogActionModal = props => {
  const {
    modalTitle,
    onClose,
    onClickButton2,
    message,
    button1,
    button2,
    isPromptBox,
    promptDetail,
    button2Variant,
    disableButton2,
    dsVersion = "1.0",
    testId = "UIComponent",
  } = props;
  const { placeholder = "", label = "", promptText = "" } = promptDetail
    ? promptDetail
    : {};
  const [inputValue, setInputValue] = useState(promptText);

  const isButton2Disabled = useMemo(
    () => disableButton2?.(inputValue) || false,
    [inputValue, disableButton2]
  );

  return (
    <Modal
      hasOverlay={true}
      isOpen={true}
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={true}
      dsVersion={dsVersion}
      onClose={onClose}
      height={dsVersion == "2.0" ? "fit-content" : "328px"}
      width={dsVersion == "2.0" ? "480px" : "584px"}
    >
      <Modal.Header isClosable={true} testId={testId}>
        <TruncatedTextWithTooltip title={modalTitle} />
      </Modal.Header>
      <Modal.Body isScrollable={true}>
        {getModalBody({
          label,
          placeholder,
          inputValue,
          setInputValue,
          message,
          isPromptBox,
          dsVersion,
          testId,
        })}
      </Modal.Body>
      <Modal.Footer>
        <div className={classes.buttonsContainer}>
          <Button
            variant={"neutral"}
            _legacy_variant={"outlined-subtle"}
            type="outlined"
            onClick={onClose}
            dsVersion={dsVersion}
            testId={`${testId}-${_.camelCase(button1)}`}
          >
            {button1}
          </Button>
          <Button
            onClick={() => onClickButton2(inputValue)}
            variant={button2Variant}
            disabled={isButton2Disabled}
            dsVersion={dsVersion}
            testId={`${testId}-${_.camelCase(button2)}`}
          >
            {button2}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default DialogActionModal;
